import React, { useState } from 'react';
import { useGetAllAddingOrdersQuery, useDeleteAddingOrderByIdMutation } from '../../../store/api/addingOrder.api';
import styles from '../OrderAdminPage/OrderAdminPage.module.css';
import { MessageModal } from '../Modal/MessageModal/MessageModal';
import { useNavigate } from 'react-router-dom';

export const AddingOrderAdminPage = () => {
	const schema = window.sessionStorage.getItem('schema');

	const { data: orders = [], isLoading, refetch } = useGetAllAddingOrdersQuery({ params: {} });
	const [activeMenu, setActiveMenu] = useState(null);
	const [statusFilter, setStatusFilter] = useState('all');
	const [currentPage, setCurrentPage] = useState(1);
	const [itemsPerPage] = useState(10);
	const [messageData, setMessageData] = useState({
		orderId: null,
		userId: null,
	});
	const navigate = useNavigate();

	console.log(orders)


	const [deleteOrder] = useDeleteAddingOrderByIdMutation();

	const handleMenuToggle = (orderId) => {
		setActiveMenu((prev) => (prev === orderId ? null : orderId));
	};


	const handleCloseMessageModal = () => {
		setMessageData({ orderId: null, userId: null });
	};

	const handleDelete = async (orderId) => {
		if (window.confirm('Вы уверены, что хотите удалить этот заказ?')) {
			try {
				await deleteOrder({ id: orderId, schema }).unwrap();
				refetch();
			} catch (error) {
				alert('Ошибка при удалении заказа');
			}
		}
	};

	// Сортировка по дате и фильтрация заказов по статусу
	const filteredOrders = orders
		.slice()
		.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
		.filter((order) => {
			if (statusFilter === 'all') return true;
			return order.status === statusFilter;
		});

	// Определяем, какие заказы показывать на текущей странице
	const indexOfLastOrder = currentPage * itemsPerPage;
	const indexOfFirstOrder = indexOfLastOrder - itemsPerPage;
	const currentOrders = filteredOrders.slice(indexOfFirstOrder, indexOfLastOrder);

	// Рассчитываем количество страниц
	const totalPages = Math.ceil(filteredOrders.length / itemsPerPage);

	// Переключение на следующую/предыдущую страницу
	const handlePageChange = (newPage) => {
		if (newPage >= 1 && newPage <= totalPages) {
			setCurrentPage(newPage);
		}
	};

	if (isLoading) {
		return <div className={styles.loading}>Загрузка...</div>;
	}

	return (
		<div className={styles.main}>
			<button onClick={() => navigate(-1)} className={styles.backButton}>
				← Назад
			</button>
			<h2 className={styles.title}>Заказы</h2>

			<div className={styles.filterWrapper}>
				<select
					value={statusFilter}
					onChange={(e) => setStatusFilter(e.target.value)}
					className={styles.filterSelect}
				>
					<option value="all">Все статусы</option>
					<option value="Оплачен">Оплачен</option>
					<option value="Отменен">Отменен</option>
					<option value="Создан">Создан</option>
				</select>
			</div>

			<div className={styles.header}>
				<div>ID/номер</div>
				<div>Сумма в рублях</div>
				<div>Статус</div>
				<div>Время заказа</div>
				<div>Пользователь ID</div>
				<div>Login</div>
				<div>Действия</div>
			</div>

			<div className={styles.list}>
				{currentOrders.map((order) => (
					<div key={order.id} className={styles.row}>
						<div>{order.id}</div>
						<div>{order.amount}</div>
						<div>{order.status}</div>
						<div>{new Date(order.createdAt).toLocaleString()}</div>
						<div>{order.userId}</div>
						<div>{order.inShop.login}</div>
						<div className={styles.actions}>
							<div onClick={() => handleMenuToggle(order.id)} className={styles.menuIcon}>
								⋮
							</div>
							{activeMenu === order.id && (
								<div className={styles.menu}>
									<div onClick={() => handleDelete(order.id)}>Удалить</div>
								</div>
							)}
						</div>
					</div>
				))}
			</div>

			{/* Пагинация */}
			<div className={styles.pagination}>
				<button
					onClick={() => handlePageChange(currentPage - 1)}
					disabled={currentPage === 1}
					className={styles.pageButton}
				>
					Назад
				</button>
				<span className={styles.pageInfo}>
					Страница {currentPage} из {totalPages}
				</span>
				<button
					onClick={() => handlePageChange(currentPage + 1)}
					disabled={currentPage === totalPages}
					className={styles.pageButton}
				>
					Вперёд
				</button>
			</div>

			{messageData.orderId && (
				<MessageModal
					isOpen={!!messageData.orderId}
					onClose={handleCloseMessageModal}
					orderId={messageData.orderId}
					userId={messageData.userId}
					schema={schema}
				/>
			)}
		</div>
	);
};
